import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getCoverageIndicatorStarted,
  getCoverageIndicatorSuccess,
  getCoverageIndicatorFailed,
} from '../../reducers/getCoverageIndicatorSlice';
import plannerGetApiCaller from '../../getApiCaller';

const API_DATA = async ({ payload }) => {
  return await plannerGetApiCaller(
    `ooh/fillRate?accountId=${payload.accountId}`,
    'Get',
    true
  ).then((response) => {
    return response;
  });
};
function* perform_getCoverageIndicatorData(params) {
  try {
    const DATA = yield call(API_DATA, params);
    yield put(getCoverageIndicatorSuccess(DATA));
  } catch (error) {
    yield put(getCoverageIndicatorFailed(error));
  }
}
export function* GET_COVERAGE_INDICATOR_SAGA() {
  yield takeLatest(
    getCoverageIndicatorStarted.type,
    perform_getCoverageIndicatorData
  );
}
